import React from "react";

import { DEVICES } from "@is/constants";

import DeviceItem from "./DeviceItem";
import css from "./SelectDevice.module.css";
import useManageSelectDevice from "./hooks/useManageSelectDevice";

const SelectDevice = () => {
  const { selectedDevice, handleSelectDeviceType } = useManageSelectDevice();

  return (
    <div className={css.container}>
      <div className={css.devicesContainer}>
        {DEVICES().map((device) => (
          <DeviceItem
            onClick={handleSelectDeviceType}
            key={device.type}
            item={device}
            isSelected={selectedDevice?.type === device.type}
          />
        ))}
      </div>
    </div>
  );
};

export default SelectDevice;
